import { render, staticRenderFns } from "./MtipoimplicadoGrid.vue?vue&type=template&id=6c834ba6"
import script from "./MtipoimplicadoGrid.vue?vue&type=script&lang=js"
export * from "./MtipoimplicadoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports